var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between align-items-start pt-3 pb-2 mb-3 border-bottom"
        },
        [
          _c("div", { staticClass: "d-inline-flex" }, [
            _c("h1", { staticClass: "h2" }, [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c("hr", { staticClass: "vertical-bar" })
          ]),
          _vm._v(" "),
          _c("b-form-input", {
            staticClass: "mr-3",
            attrs: {
              autofocus: "",
              placeholder: "Digite um termo e pressione enter para buscar"
            },
            on: {
              keyup: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.search.apply(null, arguments)
              }
            },
            model: {
              value: _vm.viewData.search,
              callback: function($$v) {
                _vm.$set(_vm.viewData, "search", $$v)
              },
              expression: "viewData.search"
            }
          }),
          _vm._v(" "),
          _c(
            "BaseButtonComponent",
            {
              attrs: {
                to: `/user/new/${_vm.profile}`,
                variant: "primary-action"
              }
            },
            [_vm._v("Novo")]
          ),
          _vm._v(" "),
          _c(
            "vue-json-to-csv",
            {
              staticClass: "ml-3",
              staticStyle: { width: "10em" },
              attrs: {
                block: "",
                "json-data": _vm.state.listCSV,
                separator: ";"
              }
            },
            [
              _c(
                "BaseButtonComponent",
                { attrs: { block: "", variant: "primary-action" } },
                [_vm._v("\n        CSV\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.viewData.loading
        ? _c("loading-list")
        : !_vm.viewData.loading && _vm.state.list && _vm.state.list.length > 0
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-between flex-column h-100" },
            [
              _c("v-table", [
                _c("thead", [
                  _c("tr", [
                    _c("td", [_vm._v("Atalhos")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Aprovado")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Nome")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("CPF/CNPJ")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Email")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.state.list, function(item) {
                    return _c("tr", { key: item.id }, [
                      _c(
                        "td",
                        { staticStyle: { "text-align": "left" } },
                        [
                          _vm.profile === "consumer" &&
                          item.parentAccount &&
                          item.parentAccount.profile === "trader"
                            ? _c(
                                "BaseButtonComponent",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  attrs: {
                                    size: "sm",
                                    to: `/user/${item.id}/sales-comissions/${item.accountId}`,
                                    title: "Comissões",
                                    variant: "info"
                                  }
                                },
                                [_c("b-icon-cash")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.profile === "partner"
                            ? _c(
                                "BaseButtonComponent",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  attrs: {
                                    size: "sm",
                                    to: `/user/${item.id}/bonuses/${item.accountId}`,
                                    title: "Bônus",
                                    variant: "info"
                                  }
                                },
                                [_c("b-icon-cash")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.profile === "trader"
                            ? _c(
                                "BaseButtonComponent",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  attrs: {
                                    size: "sm",
                                    to: `/user/${item.id}/sales-comissions-report/${item.accountId}`,
                                    title: "Comissões",
                                    variant: "secondary-action"
                                  }
                                },
                                [_c("b-icon-cash")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.profile === "consumer"
                            ? _c(
                                "BaseButtonComponent",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  attrs: {
                                    size: "sm",
                                    to: `/user/${item.id}/installations/${item.accountId}`,
                                    title: "Instalações",
                                    variant: "secondary-action"
                                  }
                                },
                                [_c("b-icon-lightning")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "BaseButtonComponent",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              attrs: {
                                size: "sm",
                                to: `/user/edit/${item.id}/${item.accountProfile}`,
                                title: "Editar",
                                variant: "secondary-action"
                              }
                            },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "pencil-square",
                                  "aria-hidden": "true"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          item.accountProfile === "consumer"
                            ? _c(
                                "BaseButtonComponent",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover",
                                      modifiers: { hover: true }
                                    }
                                  ],
                                  attrs: {
                                    size: "sm",
                                    to: `/user/view/${item.id}/consumer`,
                                    title: "Ver cadastro",
                                    variant: "secondary-action"
                                  }
                                },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "eye",
                                      "aria-hidden": "true"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "BaseButtonComponent",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              attrs: {
                                size: "sm",
                                to: `/user/${item.id}/invoices/${item.accountProfile}`,
                                title: "Ver Notas Fiscais",
                                variant: "secondary-action"
                              }
                            },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "file-text",
                                  "aria-hidden": "true"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "BaseButtonComponent",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              attrs: {
                                size: "sm",
                                title: "Excluir",
                                variant: "danger"
                              },
                              on: { click: () => _vm.remove(item) }
                            },
                            [
                              _c("b-icon", {
                                attrs: { icon: "trash", "aria-hidden": "true" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          item.loading
                            ? _c("b-icon", {
                                attrs: {
                                  icon: "arrow-clockwise",
                                  animation: "spin",
                                  "font-scale": "2"
                                }
                              })
                            : _c("b-form-checkbox", {
                                attrs: { switch: "", size: "lg" },
                                on: { change: () => _vm.setStatus(item) },
                                model: {
                                  value: item.approved,
                                  callback: function($$v) {
                                    _vm.$set(item, "approved", $$v)
                                  },
                                  expression: "item.approved"
                                }
                              })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.name))]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.formatSocialNumber(item.socialNumber))
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.email))])
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("b-pagination-nav", {
                staticClass: "mt-3",
                attrs: {
                  "link-gen": _vm.linkGen,
                  "number-of-pages": _vm.state.pageCount,
                  "use-router": ""
                }
              })
            ],
            1
          )
        : !_vm.viewData.loading
        ? _c("empty-list")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }